const config = window.DR_REFERRAL_CAPTURE_CONFIG || {};
let apiBase = String(config.apiBase || 'https://api.driveready.co').replace(/\/$/, '');

if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost') {
  apiBase = 'http://127.0.0.1:5173';
}

const storageKey = config.storageKey || 'dr_referral_context';
const visitorCookie = config.cookieVisitorKey || 'dr_referral_visitor_key';
const visitorCookieDays = Number(config.visitorCookieDays || 30);

function getCookie(name) {
  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 86400000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

function getOrCreateVisitorKey() {
  const existing = getCookie(visitorCookie);
  if (existing) return existing;

  const key =
    (window.crypto && window.crypto.randomUUID
      ? 'drv_' + window.crypto.randomUUID()
      : 'drv_' + Math.random().toString(36).slice(2) + Date.now().toString(36));

  setCookie(visitorCookie, key, visitorCookieDays);
  return key;
}

function query(name) {
  return new URL(window.location.href).searchParams.get(name);
}

function readStored() {
  try {
    const raw = localStorage.getItem(storageKey);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function writeStored(payload) {
  try {
    localStorage.setItem(storageKey, JSON.stringify(payload));
  } catch {}
}

function clean(value) {
  const out = String(value ?? '').trim();
  return out || null;
}

function currentContext() {
  return {
    referralCode: clean(query('ref')),
    visitorKey: getOrCreateVisitorKey(),
    pageUrl: window.location.href,
    pagePath: window.location.pathname + window.location.search,
    referrerUrl: document.referrer || null,
    utmSource: clean(query('utm_source')),
    utmMedium: clean(query('utm_medium')),
    utmCampaign: clean(query('utm_campaign')),
    utmContent: clean(query('utm_content')),
    utmTerm: clean(query('utm_term')),
    gclid: clean(query('gclid')),
    fbclid: clean(query('fbclid')),
    msclkid: clean(query('msclkid')),
    ttclid: clean(query('ttclid')),
    capturedAt: new Date().toISOString()
  };
}

function mergeContext(stored, current) {
  const base = stored && typeof stored === 'object' ? stored : {};

  return {
    referralCode: current.referralCode || base.referralCode || null,
    visitorKey: current.visitorKey || base.visitorKey || null,

    pageUrl: current.pageUrl || base.pageUrl || null,
    pagePath: current.pagePath || base.pagePath || null,
    referrerUrl: current.referrerUrl || base.referrerUrl || null,

    utmSource: current.utmSource || base.utmSource || null,
    utmMedium: current.utmMedium || base.utmMedium || null,
    utmCampaign: current.utmCampaign || base.utmCampaign || null,
    utmContent: current.utmContent || base.utmContent || null,
    utmTerm: current.utmTerm || base.utmTerm || null,

    gclid: current.gclid || base.gclid || null,
    fbclid: current.fbclid || base.fbclid || null,
    msclkid: current.msclkid || base.msclkid || null,
    ttclid: current.ttclid || base.ttclid || null,

    capturedAt: current.capturedAt || base.capturedAt || null
  };
}

function hasAnyTrackingValue(payload) {
  return Boolean(
    payload &&
    (
      payload.referralCode ||
      payload.utmSource ||
      payload.utmMedium ||
      payload.utmCampaign ||
      payload.utmContent ||
      payload.utmTerm ||
      payload.gclid ||
      payload.fbclid ||
      payload.msclkid ||
      payload.ttclid
    )
  );
}

async function updateCartAttributes(payload) {
  const root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const body = {
    attributes: {
      dr_referral_code: payload.referralCode || '',
      dr_referral_visitor_key: payload.visitorKey || '',
      dr_referral_captured_at: payload.capturedAt || '',
      dr_referral_page_url: payload.pageUrl || '',
      dr_referral_page_path: payload.pagePath || '',
      dr_referral_referrer_url: payload.referrerUrl || '',
      dr_referral_utm_source: payload.utmSource || '',
      dr_referral_utm_medium: payload.utmMedium || '',
      dr_referral_utm_campaign: payload.utmCampaign || '',
      dr_referral_utm_content: payload.utmContent || '',
      dr_referral_utm_term: payload.utmTerm || '',
      dr_referral_gclid: payload.gclid || '',
      dr_referral_fbclid: payload.fbclid || '',
      dr_referral_msclkid: payload.msclkid || '',
      dr_referral_ttclid: payload.ttclid || ''
    }
  };

  try {
    await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    });
  } catch {}
}

async function notifyApi(payload) {
  if (!payload.referralCode || !payload.visitorKey) return;

  try {
    await fetch(apiBase + '/api/v1/partner/touch-points', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        referralCode: payload.referralCode,
        visitorKey: payload.visitorKey,
        pageUrl: payload.pageUrl,
        pagePath: payload.pagePath,
        referrerUrl: payload.referrerUrl,
        utmSource: payload.utmSource,
        utmMedium: payload.utmMedium,
        utmCampaign: payload.utmCampaign,
        utmContent: payload.utmContent,
        utmTerm: payload.utmTerm,
        gclid: payload.gclid,
        fbclid: payload.fbclid,
        msclkid: payload.msclkid,
        ttclid: payload.ttclid
      })
    });
  } catch {}
}

async function captureCurrentReferral() {
  const stored = readStored();
  const current = currentContext();
  const payload = mergeContext(stored, current);

  if (!hasAnyTrackingValue(payload) && !payload.visitorKey) {
    return;
  }

  writeStored(payload);
  await updateCartAttributes(payload);

  if (payload.referralCode) {
    await notifyApi(payload);
  }
}

captureCurrentReferral();